import { BoltOutlined } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { Button, DialogActions, Stack, Typography } from "@mui/material";
import palette from "theme/palette";

interface ModalFooterProps {
  footerMetaText: string;
  loading: boolean;
  disabled: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

const ModalFooter = ({ footerMetaText, loading, disabled, onClose, onSubmit }: ModalFooterProps) => {
  return (
    <DialogActions
      sx={{
        pt: 2,
        borderTop: `1px solid ${palette.divider}`,
        justifyContent: "space-between",
        alignItems: { xs: "flex-start", sm: "center" },
        gap: 1,
        flexDirection: { xs: "column", sm: "row" },
      }}>
      <Typography sx={{ fontSize: 13, color: "text.secondary" }}>{footerMetaText}</Typography>
      <Stack
        direction='row'
        spacing={1}
        sx={{ ml: "0 !important" }}>
        <Button
          variant='outlined'
          color='secondary'
          onClick={onClose}>
          Отмена
        </Button>
        <LoadingButton
          variant='contained'
          onClick={onSubmit}
          loading={loading}
          disabled={disabled}
          startIcon={<BoltOutlined />}>
          Сгенерировать
        </LoadingButton>
      </Stack>
    </DialogActions>
  );
};

export default ModalFooter;
